import { useEffect, useState } from "react";
import ContractRecallGrid from "./Grid";
import { updateContractMaintenance } from "../../utils/API";
import _ from "lodash";
import { constants, messages } from "../../common/constants";
import swal from "sweetalert";

interface ContractRecallProps {
  selectedRows: any;
  updateGridCells?: any;
  setUpdatedRowIds?: any;
  setDoShowFullScreenLoader?: any;
  doShowFullScreenLoader?: any;
  handleContractRecallClose?: any;
  user?: any;
  type?: string;
}

const ContractRecall = ({
  selectedRows,
  updateGridCells,
  setDoShowFullScreenLoader,
  setUpdatedRowIds,
  doShowFullScreenLoader,
  handleContractRecallClose,
  user,
  type,
}: ContractRecallProps) => {
  const heightAG_1 = 30;
  const [contracts, setContracts] = useState<any>(selectedRows);
  const [gridApi, setGridApi] = useState<any>(null);
  const [columnApi, setColumnApi] = useState<any>(null);
  const [isValidRequest, setIsValidRequest] = useState<boolean>(false);
  const [isResetFullRecall, setResetFullRecall] = useState<boolean>(false);
  const [fullRecalledContracts, setFullRecalledContracts] = useState<any>([])
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);

  const onUpdateCell = (data: any, value: any) => {
    try {
      value =
        _.isString(data?.newValue) && data?.newValue?.includes(",")
          ? parseInt(data?.newValue?.replace(/,/g, ""))
          : data?.newValue;
      data.newValue = isNaN(value) ? 0 : parseInt(value);
      if (
        data.newValue &&
        !isNaN(data.newValue) &&
        parseFloat(data.newValue) > 0
      ) {
        data.hasError = false;
        data.newValue =
          _.isString(data?.newValue) && data?.newValue?.includes(",")
            ? parseInt(data?.newValue?.replace(/,/g, ""))
            : data?.newValue;
        let contractValue = data?.newValue * data?.contractPrice;

        data.newContractValue = data?.newValue * data?.contractPrice;
        data.remaining_quantity =
          type === "Recall"
            ? parseFloat(data?.quantity) -
              (data?.recalled_quantity + parseInt(data?.newValue))
            : parseFloat(data?.quantity) -
              (data?.total_recall_quantity + parseInt(data?.newValue));

        if (contractValue > 999999999999.99 || data.remaining_quantity < 0) {
          data.hasError = true;
        }
      } else {
        data.hasError = true;
        data.newContractValue = null;
        data.remaining_quantity = null;
        data.newValue = 0;
      }
    } catch (error) {
    } finally {
      setContracts((previousRows: any) => {
        let pRows = [...previousRows];
        let index = pRows?.findIndex(
          (x: any) =>
            x?.id === data?.id && x.contract_type === data?.contract_type
        );
        if (index >= 0) {
          data.isFullRecalledEdited = data?.isFullyRecalled && data?.remaining_quantity>0
          previousRows[index] = data;
        }
        if (index >= 0) {
          pRows[index] = data;
        }

        let errorIndex = pRows?.findIndex((x: any) => x.hasError === true);
        setIsValidRequest(errorIndex === -1);

        return pRows;
      });
    }
  };

  const updateContract = async () => {
    try {
      setDoShowFullScreenLoader(true);
      const updatedRows = contracts?.filter(
        (x: any) => x?.newValue && !_.isNaN(x?.newValue) && x?.newValue > 0
      );
      if (updatedRows && updatedRows?.length > 0) {
        let rows: any[] = [];
        let errors: any[] = [];

        rows = updatedRows.map((r: any) => ({
          contractId: r?.contract_id,
          action: "RECALL",
          bl: "L",
          changes: [
            {
              attribute: "QUANTITY_RECALLED",
              value: r?.newValue && !_.isNaN(r?.newValue) ? r?.newValue : 0,
            },
            {
              attribute: "CONTRA_PARTY",
              value: r?.cpty_id && !_.isEmpty(r?.cpty_id) ? r?.cpty_id : "",
            },
            {
              attribute: "COMMENTS",
              value: r?.comments && !_.isEmpty(r?.comments) ? r?.comments : "",
            },
          ],
        }));

        if (rows && rows?.length >= 0) {
          const accessToken = window.localStorage.getItem("refreshtoken");
          const response = await updateContractMaintenance(
            rows,
            user?.tokenType,
            accessToken
          );
          if (response?.status === 200) {
            updateGridCells(updatedRows)
            let cmUpdateResponse = await response?.json();
            cmUpdateResponse?.forEach((obj: any) => {
              if (obj.hasError === true) {
                errors.push(obj.status + " " + obj.error);
              }
            });
            if (errors.length > 0) {
              errors = _.uniq(errors);
              let error = messages.statuserror + "\n\n Error(s): \n";
              errors.map((e: any) => {
                error = error + e + "\n";
              });
              swal({
                title: constants.Error,
                text: error,
                dangerMode: true,
                closeOnClickOutside: false,
                timer: 5000,
              }).then(() => {
                setDoShowFullScreenLoader(false);
                handleContractRecallClose();
              });
            }
          }
        }
      }
    } catch (err) {
      console.log("error", err);
      setDoShowFullScreenLoader(false);
      handleContractRecallClose();
    } finally {
      setDoShowFullScreenLoader(false);
      handleContractRecallClose();
    }
  };


  useEffect(()=>{
    if(fullRecalledContracts?.length>0){
      setIsInitialLoad(false)
    }
    if(fullRecalledContracts && (!isInitialLoad || fullRecalledContracts?.length>0)){
    
    const rows =  _.map([...contracts], (value:any)=>{
        if(_.some(fullRecalledContracts, ['contract_id', value?.contract_id])){
          value.isFullyRecalled = true
          const recalledQty = value?.recalled_quantity?value?.recalled_quantity:value?.total_recall_quantity
          value.newValue = recalledQty>0? (parseFloat(value?.quantity)-recalledQty):parseFloat(value?.quantity)
          value.remaining_quantity = 0
          value.hasError = false
        }else{
          const quantity = parseFloat(value?.quantity)
          value.newValue = (quantity !==  value.newValue)? value?.newValue: null
          value.remaining_quantity = quantity !==  value.newValue ? value?.remaining_quantity: null
          value.hasError = value?.remaining_quantity < 0
          value.isFullyRecalled = false
        }

        return value
      })

      let errorIndex = rows?.findIndex(
        (x: any) => x.hasError === true
      );
      const updatedRows = rows?.filter(
        (x: any) => x?.newValue && !_.isNaN(x?.newValue) && x?.newValue > 0
      );
      setIsValidRequest(errorIndex === -1 && updatedRows?.length>0);
      setContracts([...rows])
    }
  },[fullRecalledContracts])

 
  useEffect(()=>{
    if(isResetFullRecall){
        const rows =  _.map([...selectedRows], (value:any)=>{
         return {...value, 
          isFullyReturned : false,
          newValue : null,
          remaining_quantity : null}
        })
        setIsValidRequest(false);
        setContracts([...rows])
    }
  },[isResetFullRecall])

  return (
    <>
      <ContractRecallGrid
        rowData={contracts}
        height={heightAG_1}
        onCellChange={(data: any, value: any) => {
          onUpdateCell(data, value);
        }}
        getGridApi={(gridApi: any) => {
          setGridApi(gridApi);
        }}
        getColumnApi={(columnApi: any) => {
          setColumnApi(columnApi);
        }}
        type={type}
        setSelectedRows={(rows:any)=>{
          setFullRecalledContracts(rows)
        }}
        setResetFullRecall={(isReset:boolean)=>setResetFullRecall(isReset)}
      />
      <div className="d-flex justify-content-end mt-3 ">
        <div className="ms-2 h-100 d-flex align-items-center metrics-div">
          <button
            id="submit"
            className={"btn btn-primary uploadSheet-submit-Btn"}
            onClick={() => {
              updateContract();
            }}
            disabled={!isValidRequest}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default ContractRecall;
